import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import OverlayLoader from '../components/overlayLoader';
import { showModalMessage } from '../store/modalsSlice';

import * as clientActions from '../store/clientsSlice';
import { clientsSelectors } from '../store/clientsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Create: 0,
  Edit: 1
};

const Titles = {
  [Mode.Create]: "Create new client",
  [Mode.Edit]: "Edit client"
};

const SubmitButtonCaptions = {
  [Mode.Create]: "Create",
  [Mode.Edit]: "Save"
};

class ClientEditDialog extends Component {
  initState = {
    legalForm: null,
    name: null,
    legalAddress: null,
    taxId: null,
    contactPerson: null,
    e_mail: null,
    phone: null
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onShow = this.onShow.bind(this);
    this.onClose = this.onClose.bind(this);

    this.onLegalFormChanged = this.onLegalFormChanged.bind(this);
    this.onNameChanged = this.onNameChanged.bind(this);
    this.onLegalAddressChanged = this.onLegalAddressChanged.bind(this);
    this.onTaxIdChanged = this.onTaxIdChanged.bind(this);
    this.onContactPersonChanged = this.onContactPersonChanged.bind(this);
    this.onEMailChanged = this.onEMailChanged.bind(this);
    this.onPhoneChanged = this.onPhoneChanged.bind(this);

    this.onSubmit = this.onSubmit.bind(this);
  }

  static get Mode() {
    return Mode;
  }

  onShow() {
    this.setState(this.initState);
    if (this.props.mode === Mode.Edit) {
      if (this.props.legalForm !== undefined) {
        this.setState({ legalForm: this.props.legalForm });
      }
      if (this.props.name !== undefined) {
        this.setState({ name: this.props.name });
      }
      if (this.props.legalAddress !== undefined) {
        this.setState({ legalAddress: this.props.legalAddress });
      }
      if (this.props.taxId !== undefined) {
        this.setState({ taxId: this.props.taxId });
      }
      if (this.props.contactPerson !== undefined) {
        this.setState({ contactPerson: this.props.contactPerson });
      }
      if (this.props.e_mail !== undefined) {
        this.setState({ e_mail: this.props.e_mail });
      }
      if (this.props.phone !== undefined) {
        this.setState({ phone: this.props.phone });
      }
    }
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onLegalFormChanged(e) {
    this.setState({ legalForm: e.target.value.length > 0 ? e.target.value : null });
  }

  onNameChanged(e) {
    this.setState({ name: e.target.value.length > 0 ? e.target.value : null });
  }

  onLegalAddressChanged(e) {
    this.setState({ legalAddress: e.target.value.length > 0 ? e.target.value : null });
  }

  onTaxIdChanged(e) {
    this.setState({ taxId: e.target.value.length > 0 ? e.target.value : null });
  }

  onContactPersonChanged(e) {
    this.setState({ contactPerson: e.target.value.length > 0 ? e.target.value : null });
  }

  onEMailChanged(e) {
    this.setState({ e_mail: e.target.value.length > 0 ? e.target.value : null });
  }

  onPhoneChanged(e) {
    this.setState({ phone: e.target.value.length > 0 ? e.target.value : null });
  }

  isLodaing() {
    return this.props.isClientCreating ||
      this.props.isClientUpdating;
  }

  getLoaderMessage() {
    if (this.props.isClientCreating) {
      return "Client creating...";
    }
    if (this.props.isClientUpdating) {
      return "Client updating...";
    }
  }

  isSubmitButtonDisabled() {
    return this.isLodaing() ||
      this.state.legalForm === null ||
      this.state.legalForm.length === 0 ||
      this.state.name === null ||
      this.state.name.length === 0 ||
      this.state.e_mail === null ||
      this.state.e_mail.length === 0 ||
      (this.props.mode === Mode.Edit &&
        this.state.legalForm === this.props.legalForm &&
        this.state.name === this.props.name &&
        this.state.taxId === this.props.taxId &&
        this.state.contactPerson === this.props.contactPerson &&
        this.state.e_mail === this.props.e_mail &&
        this.state.phone === this.props.phone &&
        this.state.legalAddress === this.props.legalAddress);
  }

  onSubmit() {
    this.onClose();
    let submitPromise;
    const { legalForm, name, taxId, contactPerson, e_mail, phone, legalAddress } = this.state;
    const { id } = this.props;

    switch (this.props.mode) {
      case Mode.Create:
        submitPromise = this.props.addClient({
          legalAddress, legalForm, name, taxId, contactPerson, e_mail, phone,
        });
        break;
      case Mode.Edit:
        submitPromise = this.props.updateClient({
          id, legalForm, name, taxId,
          contactPerson, e_mail, phone, legalAddress
        });
        break;
      default:
        submitPromise = null;
    }

    if (submitPromise == null) {
      this.props.showModalMessage('Error', 'Unknown dialog mode');
      return;
    }

    submitPromise
      .then(unwrapResult)
      .catch((e) => {
        console.log(e);
        console.log(this.props.onSubmitError);
        this.props.showModalMessage("Error", this.props.onSubmitError.toString());
      });
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onShow={this.onShow} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{Titles[this.props.mode]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OverlayLoader active={this.isLodaing()} text={this.getLoaderMessage()}>
            <FormGroup controlId="fcLegalForm">
              <ControlLabel>Legal form</ControlLabel>
              <FormControl value={this.state.legalForm} onChange={this.onLegalFormChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcName">
              <ControlLabel>Client name</ControlLabel>
              <FormControl value={this.state.name} onChange={this.onNameChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcAddress">
              <ControlLabel>Legal address</ControlLabel>
              <FormControl value={this.state.legalAddress} onChange={this.onLegalAddressChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcTaxId">
              <ControlLabel>Tax ID</ControlLabel>
              <FormControl value={this.state.taxId} onChange={this.onTaxIdChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcContactPerson">
              <ControlLabel>Contact person</ControlLabel>
              <FormControl value={this.state.contactPerson} onChange={this.onContactPersonChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcEMail">
              <ControlLabel>E-mail</ControlLabel>
              <FormControl value={this.state.e_mail} onChange={this.onEMailChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcPhone">
              <ControlLabel>Phone</ControlLabel>
              <FormControl value={this.state.phone} onChange={this.onPhoneChanged} type="text" />
            </FormGroup>
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            {SubmitButtonCaptions[this.props.mode]}
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isClientCreating: clientsSelectors.isCreating(state),
  isClientUpdating: clientsSelectors.isUpdating(state),
  onSubmitError: clientsSelectors.creatingUpdatingError(state),
});

const actionCreators = {
  addClient: clientActions.create,
  updateClient: clientActions.updateClient,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(ClientEditDialog);



// WEBPACK FOOTER //
// ./src/containers/clientEditDialog.js